/**
 * Enumeration of page names (app page in CMS converted to lower case)
 */
export enum ApplicationPages {
	FurtherInformation = "furtherinformationspage",
	Check = "check",
	Confirmation = "confirmationpage",
	Input = "inputpage"
}